// extracted by mini-css-extract-plugin
export default {"discountLabel":"_uayayo","appMarketText":"_4qbwpj"};